// extracted by mini-css-extract-plugin
export default {"background":"Ad_background__X7TfC","wrapper":"Ad_wrapper__KsYyL","mobile":"Ad_mobile__HtH8q","rectangleMobi":"Ad_rectangleMobi__TlO6d"};